import React from 'react'
import Tooltip from 'components/tooltip'
import { formatShortDate, formatShortDateTime } from 'helpers/date'

/** A date in a table cell as a day ("Oct 12, 2026"), with the time on hover. Blank for no date. */
const DateCell: React.FC<{ iso?: string | null }> = ({ iso }) =>
  iso ? (
    <Tooltip content={formatShortDateTime(iso)}>
      <span className="tabular-nums">{formatShortDate(iso)}</span>
    </Tooltip>
  ) : null

export default DateCell
